import { Controller } from "@hotwired/stimulus"

// Hides itself when the SIEM page query mode is anything other than ES|QL.
//
// Source of truth: accounts--logs--query-type, which combines view-mode (from
// accounts--logs--query-builder) with textarea syntax detection, mirrors the
// derived mode to document.body.dataset.logsQueryMode, and fires
// `logs:query-mode-changed` on document.
//
// Reads body on connect so late-mounting consumers (like filter buttons rendered into
// the drawer in #hotwire-modal — a sibling of the composer, not a descendant) sync
// without a race; `@document` action handles live changes from the toggle.
export default class extends Controller {
  static MODE_ESQL = "esql"

  connect() {
    this.sync(document.body.dataset.logsQueryMode)
  }

  modeChanged(event) {
    this.sync(event.detail?.mode)
  }

  sync(mode) {
    this.element.hidden = mode !== this.constructor.MODE_ESQL
  }
}
